import {EmailSettings, SendTestEmailParameters} from "@admin/models/email-settings-config";
import {Injectable} from "@angular/core";
import {catchError, firstValueFrom, map, Observable, of} from "rxjs";
import {UrlBuilderService} from "@feature/common";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";

@Injectable({ providedIn: 'root' })
export class EmailAndTestEmailService {

  constructor(private readonly http: HttpClient,
              private readonly urlBuilder: UrlBuilderService) {}

  getEmailConfig() : Observable<EmailSettings> {
    const url = this.urlBuilder.getUrl(`admin/getemailsettings`);
    return this.http.get<EmailSettings>(url);
  }

  sendTestEmail(params : SendTestEmailParameters) : Promise<string> {
    const url = this.urlBuilder.getUrl(`admin/sendtestemail`);
    const payload = {
      recipientAddress: params.address,
      messageString: params.uniqueData
    };
    const httpRequest = this.http.post(url, payload)
      .pipe(map(() => <string> null),
            catchError((err: HttpErrorResponse) => of(<string> err.error.detail)));

    return firstValueFrom(httpRequest);
  }
}
